import { GuaranteeDto } from "@lg-cfa/services";
import { equals } from "ramda";

import { DataFields } from "@enums";
import { UserDataInterface } from "@types";

export const isStateKeyEmpty = (key: string, userData: UserDataInterface) => {
    switch (key) {
        case DataFields.carType:
        case DataFields.carDescriptionMake:
        case DataFields.carDescriptionModel:
        case DataFields.carDescriptionFuel:
        case DataFields.carDescriptionPower:
        case DataFields.carDescriptionCatalogValue:
        case DataFields.carDescriptionDateRegistration:
        case DataFields.carDescriptionDatePurchased:
        case DataFields.carDescriptionInvoiceValue:
        case DataFields.carDescriptionVehicleType:
        case DataFields.driverInformationBirthday:
        case DataFields.driverInformationCity:
        case DataFields.driverInformationPostalCode:
        case DataFields.driverInformationStreet:
        case DataFields.driverInformationNumber:
        case DataFields.driverInformationLetterBox:
        case DataFields.driverHistory_License:
        case DataFields.driverHistory_Insurance:
        case DataFields.driverHistory_Accidents:
        case DataFields.carDetailsSecurityOptions:
        case DataFields.yourInformationFirstName:
        case DataFields.yourInformationLastName:
        case DataFields.yourInformationEmail:
        case DataFields.yourInformationPhone:
        case DataFields.yourInformationQuestion:
            return equals(userData[key], "");
        case DataFields.carDetailsMileage:
            return equals(userData[key], "0");
        case DataFields.insuranceChoice:
            return equals(userData[key], undefined);
        case DataFields.totalPrice:
            return equals(userData[key], 0);
        case DataFields.yourInformationConsent:
        case DataFields.flowFinished:
            return equals(userData[key], false);
        default:
            return true;
    }
};

export const sortAdditionalCovers = (additionalCovers: GuaranteeDto[]) => {
    const priorityList = ["Assistance", "Driver", "LegalAssistance"];

    return [...additionalCovers].sort((a, b) => {
        const aIndex = priorityList.indexOf(a.name ?? "");
        const bIndex = priorityList.indexOf(b.name ?? "");

        if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
        }
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;

        return 0;
    });
};
